import type { SurveyQuestionType } from "./types";

/** utility to ensure we define every survey question type as a constant with type safety */
const surveyQuestionTypeMap: Record<SurveyQuestionType, true> = {
  single_choice: true,
  single_boolean: true,
  free_form_text: true,
  nps: true,
  multiple_choice: true,
  phone_number: true,
  email: true,
};

export const surveyQuestionTypes = Object.keys(surveyQuestionTypeMap) as SurveyQuestionType[];
